<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <span class="text-2xl mr-2">🤝</span>
            <span>Students by sponsor</span>
        </h2>
        <apexchart type="bar" height="400" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "students-by-gender-sponsor",
    props: ["data"],
    data() {
        return {
            chartOptions: {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '60%',
                        dataLabels: {
                            total: {
                                enabled: true,
                                offsetX: 0,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetX: 0,
                    style: {
                        fontSize: '10px',
                        fontWeight: 900
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Number of Students',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                colors: ['#4C78A8', '#F58518'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    labels: {
                        colors: '#4A5568',
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
                // responsive: [
                //     {
                //         breakpoint: 768,
                //         options: {
                //             chart: {
                //                 height: 900,
                //             },
                //         },
                //     },
                // ],
            },
            series: [
                {
                    name: 'Male',
                    data: [],
                },
                {
                    name: 'Female',
                    data: [],
                },
            ],
        };
    },
    watch: {
        data: {
            handler(newData) {

                const categories = newData.map(item => item.sponsor);
                const maleData = newData.map(item => item.male_count);
                const femaleData = newData.map(item => item.female_count);

                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };

                this.series = [
                    {
                        name: 'Male',
                        data: maleData,
                    },
                    {
                        name: 'Female',
                        data: femaleData,
                    },
                ];
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>